/**
 * 检测图片是否存在
 * @param url 图片的 URL
 * @param maxRetries 最大重试次数，默认为 3
 * @param currentRetry 当前重试次数，默认为 0
 */
export const imageIsExist = function(url, maxRetries = 3, currentRetry = 0) {
    return new Promise((resolve) => {
        var img = new Image();
        img.onload = function () {
            if (this.complete === true) {
                resolve(true);
                img = null;
            }
        };
        img.onerror = function (error) {
            console.error(`Failed to load image ${url} (Attempt ${currentRetry + 1}):`, error);
            if (currentRetry < maxRetries) {
                // 重试
                imageIsExist(url, maxRetries, currentRetry + 1).then(resolve);
            } else {
                resolve(false);
            }
            img = null;
        };
        img.src = url;
    });
};

/**
 * 加载图片
 * @param el DOM 元素
 * @param binding 指令绑定的值
 * @param vnode Vue 虚拟节点
 */
export async function loadImage(el, binding, vnode) {
    let defaultURL = require('@/assets/img/errorImg/3.png');
    if (el.width && el.height && el.width < el.height) {
        defaultURL = require('@/assets/img/errorImg/1.png');
    }
    if (vnode.props && vnode.props.errorimg) {
        defaultURL = vnode.props.errorimg;
    }
    const imgURL = binding.value;
    if (imgURL) {
        const exist = await imageIsExist(imgURL);
        el.setAttribute('src', exist ? imgURL : defaultURL);
    } else {
        el.setAttribute('src', defaultURL);
    }
}